import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL

const token = sessionStorage.getItem('token')
axios.defaults.headers.common.Authorization = `Bearer ${token}`

async function generateLink(type, data) {
  try {
    return await axios.post(`${BASE_URL}${type}`, data)
  } catch ({ response }) {
    return response
  }
}

async function getLink(type, hash) {
  try {
    const response = await axios.get(`${BASE_URL}${type}/${hash}`)
    return response
  } catch ({ response }) {
    return response
  }
}

export {
  generateLink,
  getLink,
}
